
<template>
<div class="CajitaMenu" id="CajitaMenuT">
    <div class="HeaderMenu">
        <img @click="abreMenuModal()" class="LogoTienda" src="~@/assets/img/login/lee-letras-b.png">
        <div class="CajitaMenuOpt">
            <div @click="CambiaVista('Ventas',1)" id="Ventas" class="cajitasMenuOpti CMO active"><img src="~@/assets/img/menu/huellita-blanca.png" v-if="Ventas"> Ventas</div>
            <div v-if="isAdmin" @click="CambiaVista('Inventario',1)" id="Inventario" class="cajitasMenuOpti CMO"><img src="~@/assets/img/menu/huellita-blanca.png" v-if="Inventario"> Inventario</div>
            <div v-if="isAdmin" @click="CambiaVista('Usuarios',1)" id="Usuarios" class="cajitasMenuOpti CMO"><img src="~@/assets/img/menu/huellita-blanca.png" v-if="Usuarios"> Usuarios</div>
            <div @click="CambiaVista('Cerrar',1)" id="Cerrar" class="cajitasMenuOpti ">Cerrar sesión</div>
        </div>
        <button @click="abreMenuModal()" class="btn btn-outline-light rounded-pill BtnAbremenus" type="button">Menu <i class="fa fa-bars" aria-hidden="true"></i></button>
    </div>
    <div class="BodyMenu">
        <VentasVue v-if="Ventas"/>
        <!-- <app-ventas [isAdmin]="isAdmin" [LlegaLogin]="DataGeneral" *ngIf="Ventas"></app-ventas>
        <app-inventario *ngIf="Inventario"></app-inventario>
        <app-usuarios *ngIf="Usuarios"></app-usuarios> -->
    </div>
    <div class="MenuModal animate__animated animate__fadeIn animate__faster" @click="abreMenuModal()" id="MenuModal" v-if="LHAModalMenu">
    </div>
    <div class="contentMenuModal animate__animated animate__slideInLeft animate__faster" id="contentMenuModal" v-if="LHAModalMenu">
        <i @click="abreMenuModal()" class="bi bi-x iconCerrar"></i>
        <div class="FotoPerfil">
            <div class="circular--portrait">
                <img src="~@/assets/img/login/lee-blanco.png">
            </div>
            <div class="col-12"></div>
            <h3 class="TextNombre">{{DataGeneral[0].USU_NOMBRE}}</h3>
        </div>
        <div @click="CambiaVista('Ventas',2)" id="Ventas2" class="col-12 CajitasVIRU CajitasV"><img src="~@/assets/img/menu/huellita-blanca.png" v-if="Ventas"> Ventas</div>
        <div v-if="isAdmin" @click="CambiaVista('Inventario',2)" id="Inventario2" class="col-12 CajitasVIRU CajitasI"><img src="~@/assets/img/menu/huellita-blanca.png" v-if="Inventario"> Inventario</div>
        <div v-if="isAdmin" @click="CambiaVista('Usuarios',2)" id="Usuarios2" class="col-12 CajitasVIRU CajitasU"><img src="~@/assets/img/menu/huellita-blanca.png" v-if="Usuarios"> Usuarios</div>
        <div @click="CambiaVista('Cerrar',2)" id="Cerrar2" class="col-12 CajitasVIRU CajitasU">Cerrar sesión</div>
    </div>
</div>
<div class="Cargando" v-if="Cargando">
    <div class="wrapper">
        <div class="circle circle1"></div>
        <div class="circle circle2"></div>
        <div class="circle circle3"></div>
        <div class="shadow"></div>
        <div class="shadow"></div>
        <div class="shadow"></div>
        <span>Cargando</span>
    </div>
</div>
</template>

<script lang="ts">
import { defineComponent, toRefs, ref } from 'vue';
import VentasVue  from './ventas.vue';

export default defineComponent({
    name: 'MenuVue',
    data() {
         let Cargando = false;
         let LHAModalMenu = false;
         let isAdmin = true
         let Ventas = true;
         let Inventario = false;
         let Usuarios = false;
         let DataGeneral:Array<any> = [];
         let LlegaDelLogin:any = [];
        return {Cargando, LHAModalMenu, isAdmin, Ventas, Inventario, Usuarios, DataGeneral,LlegaDelLogin}
    },
    props: {
        message: {
        default: 'No hay nada UwU'
        }
    },
    setup(props) {

        const message2  = toRefs(props);

        return { message2 };
    },
    mounted() {
        // console.log(this.message);
        this.LlegaDelLogin = JSON.parse(JSON.stringify(this.message))
        // this.message;
        this.IsertData();
    },
    methods: {
        IsertData(){
            // console.log(this.LlegaDelLogin);
            this.DataGeneral.push({
            USU_ID: this.LlegaDelLogin.USU_ID,
            USU_NOMBRE: this.LlegaDelLogin.USU_NOMBRE,
            USU_TIPO: this.LlegaDelLogin.USU_TIPO,
            USU_USERNAME: this.LlegaDelLogin.USU_USERNAME,
            USU_PASSWORD: this.LlegaDelLogin.USU_PASSWORD,
            USU_ESTATUS: this.LlegaDelLogin.USU_ESTATUS
            });
            if(this.DataGeneral[0].USU_TIPO=='ADMIN'){
            this.isAdmin=true;
            }else{
            this.isAdmin=false;
            }
        },
        abreMenuModal(){
            if(this.LHAModalMenu == false){
                this.LHAModalMenu = !this.LHAModalMenu;
                if(this.Ventas==true){
                    setTimeout(() => {
                    this.CambiaVista('Ventas',3);
                    }, 5);
                }
                if(this.Inventario==true){
                    setTimeout(() => {
                    this.CambiaVista('Inventario',3);
                    }, 5);
                }
                if(this.Usuarios==true){
                    setTimeout(() => {
                    this.CambiaVista('Usuarios',3);
                    }, 5);
                }
            }else{
                let div1:any = document.getElementById('MenuModal');
                div1.classList.remove('animate__fadeIn');
                div1.classList.add('animate__fadeOut');
                let div2:any = document.getElementById('contentMenuModal');
                div2.classList.remove('animate__slideInLeft');
                div2.classList.add('animate__slideOutLeft');
                setTimeout(() => {
                    this.LHAModalMenu = !this.LHAModalMenu;
                }, 500);
            }

        },
        CambiaVista(vista:string,tipo:any){
            this.Ventas = false;
            this.Inventario = false;
            this.Usuarios = false;
            if(tipo==1 || tipo==2){
                let divVent:any = document.getElementById('Ventas');
                let divInv:any = document.getElementById('Inventario');
                let divUsu:any = document.getElementById('Usuarios');
                let divCer:any = document.getElementById('Cerrar');
                let active:any = document.getElementsByClassName('active');
                if(active.length!=0){
                    active[0].classList.remove('active');
                }
                switch (vista) {
                    case 'Ventas':
                    this.Ventas = true;
                    this.Inventario = false;
                    this.Usuarios = false;
                    divVent.classList.add('active');
                    break;
                    case 'Inventario':
                    this.Ventas = false;
                    this.Inventario = true;
                    this.Usuarios = false;
                    divInv.classList.add('active');
                    break;
                    case 'Usuarios':
                    this.Ventas = false;
                    this.Inventario = false;
                    this.Usuarios = true;
                    divUsu.classList.add('active');
                    break;
                    case 'Cerrar':
                    divCer.classList.add('active');
                    // this.cierraMenu.emit(true);
                    localStorage.clear();
                    window.location.reload();
                    break;
                    default:
                    console.log('Lo lamentamos, por el momento no disponemos de ' + vista + '.');
                }
            }
            if(tipo==2){
                let divVent:any = document.getElementById('Ventas2');
                let divInv:any = document.getElementById('Inventario2');
                let divUsu:any = document.getElementById('Usuarios2');
                let divCer:any = document.getElementById('Cerrar2');
                let active:any = document.getElementsByClassName('activo');
                if(active.length!=0){
                    active[0].classList.remove('activo');
                }
                switch (vista) {
                    case 'Ventas':
                    this.Ventas = true;
                    this.Inventario = false;
                    this.Usuarios = false;
                    divVent.classList.add('activo');
                    this.abreMenuModal();
                    break;
                    case 'Inventario':
                    this.Ventas = false;
                    this.Inventario = true;
                    this.Usuarios = false;
                    divInv.classList.add('activo');
                    this.abreMenuModal();
                    break;
                    case 'Usuarios':
                    this.Ventas = false;
                    this.Inventario = false;
                    this.Usuarios = true;
                    divUsu.classList.add('activo');
                    this.abreMenuModal();
                    break;
                    case 'Cerrar':
                    divCer.classList.add('activo');
                    // this.cierraMenu.emit(true);
                    // this.abreMenuModal();
                    localStorage.clear();
                    window.location.reload();
                    break;
                    default:
                    console.log('Lo lamentamos, por el momento no disponemos de ' + vista + '.');
                }
            }
            if(tipo==3){
                let divVent:any = document.getElementById('Ventas2');
                let divInv:any = document.getElementById('Inventario2');
                let divUsu:any = document.getElementById('Usuarios2');
                let divCer:any = document.getElementById('Cerrar2');
                let active:any = document.getElementsByClassName('activo');
                if(active.length!=0){
                    active[0].classList.remove('activo');
                }
                switch (vista) {
                    case 'Ventas':
                    this.Ventas = true;
                    this.Inventario = false;
                    this.Usuarios = false;
                    divVent.classList.add('activo');
                    break;
                    case 'Inventario':
                    this.Ventas = false;
                    this.Inventario = true;
                    this.Usuarios = false;
                    divInv.classList.add('activo');
                    break;
                    case 'Usuarios':
                    this.Ventas = false;
                    this.Inventario = false;
                    this.Usuarios = true;
                    divUsu.classList.add('activo');
                    break;
                    case 'Cerrar':
                    divCer.classList.add('activo');
                    // this.cierraMenu.emit(true);
                    localStorage.clear();
                    window.location.reload();
                    break;
                    default:
                    console.log('Lo lamentamos, por el momento no disponemos de ' + vista + '.');
                }
            }
        }
    }, 
    components:{
        VentasVue
    }
})
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@font-face {
    font-family: 'ZonaProBold';
    src: url(~@/assets/fonts/ZonaPro-Bold.ttf);
}

@font-face {
    font-family: 'ZonaProSemiBold';
    src: url(~@/assets/fonts/ZonaPro-SemiBold.ttf);
}

@font-face {
    font-family: 'ZonaProItalic';
    src: url(~@/assets/fonts/ZonaPro-RegularItalic.ttf);
}

@font-face {
    font-family: 'ZonaPro';
    src: url(~@/assets/fonts/ZonaPro-Regular.ttf);
}
.CajitaMenu {
    width: 100vw;
    height: 100vh;
    overflow: auto;
    position: relative;
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    align-content: space-between;
    /*background-image: url('https://tesis.lmspace.com.mx/angular/assets/img/menu/fondo-Cat4.png'), linear-gradient(to right, #CCB6EE 30%, #70C0E8 100%);*/
    background-image: url('~@/assets/img/menu/fondo-Cat4.png'), linear-gradient(to right, #CCB6EE 30%, #70C0E8 100%);
    // background-image: url('/tienda-angular/assets/img/menu/fondo-Cat4.png'), linear-gradient(to right, #CCB6EE 30%, #70C0E8 100%);
    background-size: cover;
}

.HeaderMenu {
    position: sticky;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #8869a5;
    box-shadow: #32325d8c 0 6px 12px -2px, #000000a1 0 3px 7px -3px;
    padding: 0.5rem;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    align-content: center;
    color: white;
}

.LogoTienda {
    width: 4%;
}


/*.HMA { color: inherit; text-decoration: none; cursor: pointer; } .menu { display: flex; justify-content: center; list-style: none; font-family: 'ZonaPro'; margin-bottom: 0; padding-left: 0; } .menu li { margin-right: 70px; margin-right: calc(1rem + 1vw); } .menu a { position: relative; display: block; padding: 5px; } .menu a::before { content: ''; position: absolute; bottom: 0; left: 0; width: 100%; height: 2px; background: linear-gradient(to right, #b47dcd, #e878a2, #eb85ab); z-index: 1; transform: scaleX(0); transform-origin: left; transition: transform 0.5s ease-in-out; } .menu a:hover::before { transform: scaleX(1); } *--------------------------------------------------ANIMATIONS–––––––––––––––––––––––––––––––––––––––––––––––––– * .menu[data-animation="center"] a::before { transform-origin: center; } *------------------------------------------------------------–––––––––––––––––––––––––––––––––––––––––––––––––– */

.BtnAbremenus {
    font-family: 'ZonaProBold';
    padding: 0.5rem 3rem;
    font-size: 1.2rem;
    background-color: white;
    color: black;
    display: none;
}

.BtnAbremenus:hover {
    background-color: transparent;
    /*#644283*/
    color: white;
}

.MenuModal {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba( #00acc1, .65);
    z-index: 1;
}

.contentMenuModal {
    position: fixed;
    left: 0;
    top: 0;
    width: 400px;
    max-width: 100%;
    height: 100%;
    background-color: white;
    box-shadow: rgba(0, 0, 0, 0.15) 2.4px 2.4px 3.2px;
    padding: .5rem;
    z-index: 1;
    text-align: right;
    overflow: auto;
}

.contentMenuModal::-webkit-scrollbar {
    width: 8px;
    /* Tamaño del scroll en vertical */
    height: 8px;
    /* Tamaño del scroll en horizontal */
    /*display: none; Ocultar scroll */
}

.contentMenuModal::-webkit-scrollbar-thumb {
    /* thumb */
    background: #cacaca;
    border-radius: 50px;
    height: 50px;
}

.contentMenuModal::-webkit-scrollbar-track {
    /* track */
    background: white;
    border-radius: 50px;
}


/*.HMA2 { color: inherit; text-decoration: none; } .menu2 { display: flex; justify-content: center; list-style: none; flex-flow: row wrap; padding-left: 0; padding-top: 2rem; font-family: "ZonaPro"; } .menu2 li { *margin-right: 70px;* width: 100%; height: 8rem; text-align: center; margin-bottom: 1rem; background-color: #c3e9ec; } .menu2 li :hover { background-color: #cfbffa; } .menu2 a { position: relative; display: block; padding: 10px; height: 100%; display: flex; flex-flow: row wrap; justify-content: center; align-items: center; align-content: center; } .menu2 .border { position: absolute; left: 0; background: #a88eef; transition: transform 0.3s ease-in-out; } .menu2 .border-top, .menu2 .border-bottom { width: 100%; height: 1px; transform: scaleX(0); } .menu2 .border-left, .menu2 .border-right { width: 1px; height: 100%; transform: scaleY(0); } .menu2 .border-top, .menu2 .border-left, .menu2 .border-right { top: 0; } .menu2 .border-bottom { bottom: 0; transform-origin: bottom right; } .menu2 .border-top { transform-origin: top left; } .menu2 .border-left { transform-origin: bottom left; } .menu2 .border-right { left: auto; right: 0; transform-origin: top right; } .menu2 a:hover .border-top, .menu2 a:hover .border-bottom { transform: scaleX(1); } .menu2 a:hover .border-left, .menu2 a:hover .border-right { transform: scaleY(1); } .menu2 a:hover .border-right { transition-delay: 0.2s; } .menu2 a:hover .border-bottom { transition-delay: calc(0.2s * 2); } .menu2 a:hover .border-left { transition-delay: calc(0.2s * 3); } .border { border: 1px solid #a88eef !important; } *----------------------------ANIMATIONS––––––––––––––––––––––––––––––––––––– * .menu2[data-animation="diagonal"] .border-left { transform-origin: top left; } .menu2[data-animation="diagonal"] .border-right, .menu2[data-animation="diagonal"] .border-bottom { transform-origin: bottom right; } .menu2[data-animation="diagonal"] a:hover [class^=border] { transition-delay: 0s; }* *------------------------–––––––––––––––––––––––––––––––––––––––––––––––––– */

.iconCerrar {
    font-size: 2.5rem;
    cursor: pointer;
}

.CajitaMenuOpt {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    align-content: center;
    font-family: "ZonaPro";
    width: auto;
}

.cajitasMenuOpti {
    padding: .5rem;
    cursor: pointer;
    width: fit-content;
    color: white;
}

.cajitasMenuOpti:hover {
    color: #D47BBD;
}

.CMO {
    margin-right: 1vw;
}

.active,
.active:hover {
    font-family: 'ZonaProBold';
    color: white;
    background-color: rgba( #fff, .15);
    border-radius: 500px;
}

.active>img {
    width: 1rem;
}

.FotoPerfil {
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    align-items: center;
    align-content: center;
}

.circular--portrait {
    width: 8rem;
    height: 8rem;
    overflow: hidden;
    border-radius: 500%;
    border: 5px solid #D47BBD;
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    align-items: center;
    align-content: center;
    background-color: rgba(212, 123, 189, .5);
}

.circular--portrait img {
    width: 100%;
    height: auto;
}

.BodyMenu {
    height: 85%;
    width: 90%;
    background-color: white;
    border-top-left-radius: 0.8rem;
    border-top-right-radius: 0.8rem;
    padding: 1.5rem 2rem;
    overflow: auto;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset;
}

.BodyMenu::-webkit-scrollbar {
    width: 8px;
    /* Tamaño del scroll en vertical */
    height: 8px;
    /* Tamaño del scroll en horizontal */
    /*display: none; Ocultar scroll */
}

.BodyMenu::-webkit-scrollbar-thumb {
    /* thumb */
    background: #cacaca;
    border-radius: 50px;
    height: 50px;
}

.BodyMenu::-webkit-scrollbar-track {
    /* track */
    background: white;
    border-radius: 50px;
}

.CajitasVIRU {
    height: 8rem;
    background-color: #DCE7EF;
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    align-items: center;
    align-content: center;
    cursor: pointer;
    margin-bottom: 1rem;
    font-family: 'ZonaPro';
    font-size: 1.5rem;
    position: relative;
}

.CajitasVIRU>img {
    width: 4rem;
    margin-right: 1rem;
    position: absolute;
    left: 10%;
}

.CajitasI>img {
    left: 6%;
}

.CajitasV {
    background-color: #C3E9EC;
    background-color: #AFE8FC;
}

.CajitasI {
    background-color: #AFE8FC;
}

.CajitasU {
    background-color: #AFE8FC;
}

.CajitasR {
    background-color: #AFE8FC;
}

.CajitasV:hover,
.CajitasV:active {
    background-color: #A88EEF;
    color: white;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;
}

.CajitasI:hover,
.CajitasI:active {
    background-color: #A88EEF;
    color: white;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;
}

.CajitasU:hover,
.CajitasU:active {
    background-color: #A88EEF;
    color: white;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;
}

.CajitasR:hover,
.CajitasR:active {
    background-color: #A88EEF;
    color: white;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;
}

.activo,
.activo:hover,
.activo:active {
    background-color: #217EDD;
    /*border: 5px solid #F1E196;*/
    box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;
    color: #EAAE7A;
    color: white;
    /*text-decoration: underline;*/
    font-family: 'ZonaProBold';
    font-size: 2rem;
}

.flecha-up {
    width: 0px;
    height: 0px;
    border-left: 16px solid transparent;
    /* izquierda flecha */
    border-right: 16px solid transparent;
    /* derecha flecha */
    border-bottom: 16px solid white;
    /* base flecha y color*/
    font-size: 0px;
    line-height: 0px;
    position: absolute;
    right: 10px;
    top: -16px;
}


/*-------------------------------Login---------------------------------------*/

.Cargando {
    /*background-color: rgba( #7896D2, 0.95);*/
    background-color: rgba( #A381AA, 0.85);
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 10;
}

.wrapper {
    width: 200px;
    height: 60px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.circle {
    width: 20px;
    height: 20px;
    position: absolute;
    border-radius: 50%;
    background-color: #fff;
    left: 15%;
    transform-origin: 50%;
    animation: circle .5s alternate infinite ease;
}

.circle1 {
    background-color: rgba( #E5A5DF, 1.0);
}

.circle2 {
    background-color: #CEB2EE;
}

.circle3 {
    background-color: #B3C4F9;
}

@keyframes circle {
    0% {
        top: 60px;
        height: 5px;
        border-radius: 50px 50px 25px 25px;
        transform: scaleX(1.7);
    }
    40% {
        height: 20px;
        border-radius: 50%;
        transform: scaleX(1);
    }
    100% {
        top: 0%;
    }
}

.circle:nth-child(2) {
    left: 45%;
    animation-delay: .2s;
}

.circle:nth-child(3) {
    left: auto;
    right: 15%;
    animation-delay: .3s;
}

.shadow {
    width: 20px;
    height: 4px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, .5);
    position: absolute;
    top: 62px;
    transform-origin: 50%;
    z-index: -1;
    left: 15%;
    filter: blur(1px);
    animation: shadow .5s alternate infinite ease;
}

@keyframes shadow {
    0% {
        transform: scaleX(1.5);
    }
    40% {
        transform: scaleX(1);
        opacity: .7;
    }
    100% {
        transform: scaleX(.2);
        opacity: .4;
    }
}

.shadow:nth-child(4) {
    left: 45%;
    animation-delay: .2s
}

.shadow:nth-child(5) {
    left: auto;
    right: 15%;
    animation-delay: .3s;
}

.wrapper span {
    position: absolute;
    top: 75px;
    font-family: 'ZonaProBold';
    font-size: 2rem;
    letter-spacing: 12px;
    color: #fff;
    text-shadow: 4px 3px 0 #7A51A1;
    left: 15%;
    letter-spacing: 8px;
    left: -4%;
    top: 80px;
}


/*---------------------------------------------------------------------------*/

@media screen and (max-width: 500px) {
    .BtnAbremenus {
        display: block;
    }
    .CajitaMenuOpt {
        display: none;
    }
    .LogoTienda {
        width: 12%;
    }
    .BodyMenu {
        height: 88%;
        width: 94%;
    }
}
</style>
